import React, {Component} from 'react';

import VerificationForm from './VerificationForm.js';

class App extends Component {

  render() {
    return (<VerificationForm {...this.props}/>);
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js